export const mainTitle = "Ponte coa Lusofonía"
export const mainSubtitle = "5, 12, 19, 26 de outubro do 2024"
export const mainUrl = "https://pontecoalusofonia.abella.gal"
export const mainDescription = "O Encontro do Cinema Lusófono"
